import styles from "./FnaSection.module.css";

type FnaTabItem = {
  key: "basic" | "analysis" | "history";
  label: string;
};

type FnaTabsProps = {
  tabs: FnaTabItem[];
  activeKey: FnaTabItem["key"];
  onChange: (key: FnaTabItem["key"]) => void;
};

export function FnaTabs({ tabs, activeKey, onChange }: FnaTabsProps) {
  return (
    <div className={styles.fnaTabs}>
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        return (
          <button
            key={tab.key}
            type="button"
            className={`${styles.fnaTab} ${isActive ? styles.fnaTabActive : ""}`}
            onClick={() => onChange(tab.key)}
          >
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
